import * as React from 'react';
import './footer.scss';

const Footer = () => (
  <footer className="footer u-colorNeutral6">
    <p>TeamSnap for Business</p>
  </footer>
);

export default Footer;
